var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#ffffff",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1365,
    height: 158,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1365 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(682.5,79) scale(1,-1) translate(-682.5,-79)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.8206345242958784",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0b65c6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6e0bc6",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8206345242958784)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 126.4Q 170.625 163.47389028148814  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 177.9658837350019  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 162.32237893442604  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 163.47389028148814  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8206345242958784)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-3.3333333333333335s",
    values: "M0 0L 0 126.4Q 170.625 161.05342225684498  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 153.8196974831668  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 141.52631464925847  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 161.05342225684498  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8206345242958784)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-6.666666666666667s",
    values: "M0 0L 0 126.4Q 170.625 152.85278182329978  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 154.4212452391587  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 162.77729416380225  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z;M0 0L 0 126.4Q 170.625 152.85278182329978  341.25 126.4T 682.5 126.4T 1023.75 126.4T 1365 126.4L 1365 0 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner04);
export default __webpack_public_path__ + "static/media/banner04.b43b10b807bb6396ac4915f44ff5c6ff.svg";
export { ForwardRef as ReactComponent };